import React, { Component, ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { ModalRouter } from 'context/ModalRouter';
import { Store } from 'redux';
import UserPermissionsProvider from 'components/user/permissions/UserPermissionsProvider';
import ReactQueryDevTools from 'components/shared/ReactQueryDevTools';
import store from 'store';
import { Dispatch } from 'types/Store';
import { AppThunks } from 'modules/app/appActions';
import { queryClient } from 'api/client';
import AccountOnboardingChecker from 'app/modules/onboarding/components/AccountOnboardingChecker';
import { AiUsageLimitModalProvider } from 'app/modules/aiContent/components/AiUsageLimitModalProvider';
import PaymentMethodUpgradeProvider from 'app/modules/settings/modules/billing/components/PaymentMethodUpgradeProvider';

// Workaround of code-splitting issue
import 'utils/hooks/useElementSize';
import 'utils/hooks/useWindowsSize';

type Props = {
  children: React.ReactNode;
  queryClient: QueryClient;
  store: Store;
};

class PrivateAppProviders extends Component<{ children: ReactNode }, Props> {
  constructor(props: Props) {
    super(props);
    store.dispatch<Dispatch>(AppThunks.initializeApp());
  }

  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevTools>
          <Provider store={store}>
            <UserPermissionsProvider>
              <AccountOnboardingChecker>
                <ModalRouter>
                  <AiUsageLimitModalProvider>
                    {this.props.children}
                    <PaymentMethodUpgradeProvider />
                  </AiUsageLimitModalProvider>
                </ModalRouter>
              </AccountOnboardingChecker>
            </UserPermissionsProvider>
          </Provider>
        </ReactQueryDevTools>
      </QueryClientProvider>
    );
  }
}

export default PrivateAppProviders;
